import { Issuers } from '@/constants/issuers';

import type { TokenResult } from './0x/token-registry.types';

export type ZoraType = 'creator' | 'post' | undefined;
const ZORA_CREATOR_COIN_EVENT = 'CreatorCoinCreated';

/**
 * Check if a token is issued by Zora
 */
export const isZoraToken = (token: TokenResult | undefined): boolean => {
  return token?.issuer?.name === Issuers.ZORA;
};

/**
 * Check if a Zora token is a creator coin
 */
export const isZoraCreatorCoin = (token: TokenResult | undefined): boolean => {
  if (!token?.issuer?.metadata) return false;
  const metadata = token.issuer.metadata as { eventName?: string } | unknown;
  return (
    typeof metadata === 'object' &&
    metadata !== null &&
    'eventName' in metadata &&
    metadata.eventName === ZORA_CREATOR_COIN_EVENT
  );
};
